export const LOGISTICS_PAYMENT_SOURCES = {
  customer: { label: "Facture client", type: "in", permission: "logistics.customer_payments" },
  supplier: { label: "Facture fournisseur", type: "out", permission: "logistics.supplier_payments" },
  expense: { label: "Charge Admin", type: "out", permission: "logistics.expenses.entries" },
};

export const logisticsPaymentPermission = (source, action) => {
  const config = LOGISTICS_PAYMENT_SOURCES[source];
  if (!config) return "";
  const suffix = source === "expense"
    ? { view: "view_payments", create: "create_payment", edit: "edit_payment", delete: "delete_payment" }[action]
    : action;
  return `${config.permission}.${suffix}`;
};

export const formatLogisticsAmount = (amount, symbol) =>
  `${Number(amount || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${symbol ? ` ${symbol}` : ""}`;

export const logisticsPaymentKey = (payment) => `${payment.source}:${payment.id}`;

export const logisticsPaymentReference = (payment) => payment.payment_reference || `Paiement #${payment.id}`;
